<template>
    <DCard padding>
        <DTable
            :items="supportLinks"
            :fields="fields"
        >
            <template #tool="{item}">
                <td>
                    <a
                        :href="item.url"
                        target="_blank"
                    >
                        {{ item.label }}
                    </a>
                </td>
            </template>
        </DTable>
    </DCard>
</template>

<script setup>
import { computed } from 'vue'
import { __ } from '~@/Composables/translation'

defineProps({
    supportLinks: {
        type: Array,
        default: () => []
    }
})

const fields = computed(() => [
    {
        key: 'module',
        label: __('tools.support_links.module')
    },
    {
        key: 'tool',
        label: __('tools.support_links.tool')
    }
])
</script>
